import Shepherd from 'shepherd.js';

export type ShepherdTourOptions = NonNullable<ConstructorParameters<typeof Shepherd.Tour>[0]>;

export const DEFAULT_TOUR_OPTIONS: ShepherdTourOptions = {
  useModalOverlay: true,
  exitOnEsc: false,
  classPrefix: 'app-tour',
  defaultStepOptions: {
    scrollTo: { behavior: 'smooth', block: 'center' },
    cancelIcon: {
      enabled: true,
    },
    highlightClass: 'tour-highlight',
    modalOverlayOpeningPadding: 10,
  },
};

type ShepherdTour = InstanceType<typeof Shepherd.Tour>;

export const TOUR_BUTTONS = {
  back: {
    text: '← Back',
    action(this: ShepherdTour) {
      this.back();
    },
    classes: 'shepherd-button-secondary',
  },
  next: {
    text: 'Next →',
    action(this: ShepherdTour) {
      this.next();
    },
    classes: 'shepherd-button-primary',
  },
  ok: {
    text: 'OK',
    action(this: ShepherdTour) {
      this.next();
    },
    classes: 'shepherd-button-primary',
  },
  finish: {
    text: 'Finish ✓',
    action(this: ShepherdTour) {
      this.complete();
    },
    classes: 'shepherd-button-primary shepherd-button-finish',
  },
  skip: {
    text: 'Skip Tour',
    action(this: ShepherdTour) {
      void this.cancel();
    },
    classes: 'shepherd-button-secondary shepherd-button-skip',
  },
  skipOnly: {
    text: 'Skip tour',
    action(this: ShepherdTour) {
      void this.cancel();
    },
    classes: 'shepherd-button-secondary shepherd-button-skip',
  },
};
